import React, { useState, useEffect } from 'react';
import TablaDinamica from '../util/TablaDinamica';
import FuncionesAjusteInventario from './Funciones/FuncionesAjusteInventario';
import FuncionesGenerales from '../util/FuncionesGenerales';
import instanciaAxios, { esErrorPermiso } from '../../miscelaneo/instanciaAxios';
import SpinnerCargando from '../util/SpinnerCargando';
import { toast } from 'react-toastify';
import { FaDollarSign } from "react-icons/fa";
import DockVerticalDerecha from '../estructura/DockVerticalDerecha';
import DetalleFacturacion from '../util/DetalleFacturacion';
import { useContextoSesion } from '../../miscelaneo/ContextoSesion'; // Importa el hook del contexto
import PlantillaModal from '../util/PlantillaModal';
import TablaAjusteInventario from '../util/tablas/TablaAjusteInventario';
import { MdWarning } from 'react-icons/md';
import { noEsFechaHoraFutura } from '../util/ValidacionesCampos';

function ProcesoAjuste() {
    const {usuario} = useContextoSesion();
    const {generarCamposFormulario} = FuncionesAjusteInventario()
    const {obtenerFechaHoraActual, formatoMoneda, formatearFechaHoraInput} = FuncionesGenerales(usuario)
    const [nombresProductos,setNombresProductos] = useState([])
    const [formData, setFormData] = useState({});
    const [sucursal,setSucursal] = useState([])
    const [motivoAjuste,setMotivoAjuste] = ([])
    const [cargando,setCargando] = useState(false)
    const [campos,setCampos] = useState([])
    const [costoTotal,setCostoTotal] = useState(0)
    const [editable,setEditable] = useState(true)
    const [modo,setModo] = useState('creacion')
    const [mostrarModalAjusteInventario,setMostrarModalAjusteInventario] = useState(false);
    const handleChange = (e) => {
        const { id, value, type, checked } = e.target;
        // console.log(e.target.id)
            if (id === 'id_sucursal') {
            if (formData.detallesAjuste?.length > 0) {
                toast.error('Si va a cambiar de sucursal, debe eliminar los detalles del ajuste de inventario.');
                return;
            }
            }
        setFormData((prev) => ({
            ...prev,
            [id]: type === 'checkbox' ? checked : value,
        }));


    };


    const camposFiltrados = campos;

    const camposPorSeccion = camposFiltrados.reduce((acc, campo) => {
        if (!acc[campo.seccion]) acc[campo.seccion] = [];
        acc[campo.seccion].push(campo);
        return acc;
    }, {});

      useEffect(() => {
    const fetchData = async () => {
      try {
        setCargando(true)
        const [ sucursales, motivos_ajuste ] = await Promise.all([
          instanciaAxios.get('/miscelaneo/sucursal'),
          instanciaAxios.get('/inventario/ajuste/motivo'),

        ]);
        setSucursal(sucursales.data);
        // setListasPrecio(listas_precio.data)
        // setUnidadMedida(unidad_medida.data)
        // setCategoria(categorias.data)
        // setMarca(marcas.data)
        // setTipoProducto(tipos_producto.data)
        // setImpuesto(impuestos.data)

           setCampos(generarCamposFormulario(sucursales.data,motivos_ajuste.data))
           setFormData((prev) =>({
            ...prev,
            fecha_hora:obtenerFechaHoraActual(),
            usuario: usuario.nombre +' '+ (usuario.apellido? usuario.apellido : '')
            

           }))

      } catch (error) {
        if (esErrorPermiso(error)) return;
        console.error('Error fetching data:', error);
        toast.error('Error al cargar datos iniciales');
      } finally {
        setCargando(false); // 2. Desactivar loading
      }
    };
    fetchData();
  }, []);
  useEffect(() => {
    console.log(nombresProductos)
  }, [formData]);

function handleDetalleAjusteChange(detallesAjuste) {
    // Calcular el costo total
    const costoTotal = detallesAjuste.reduce((acc, item) => {
        return acc + (parseFloat(item.costo) * parseFloat(item.cantidad));
    }, 0);

    // Actualizar el estado
    setFormData((prev) => ({
        ...prev,
        detallesAjuste: detallesAjuste,
    }));

    // Establecer el costo total
    setCostoTotal(costoTotal);
}


async function submitAjusteInventario() {
    if (cargando) return;
    console.log(formData)
    try {
        if (modo == 'edicion' && !formData.comentario) {
            toast.error('Para editar, debes ingresar un comentario, ya que es el único campo modificable.')
            return
        }
        if (modo == 'ver') {
            toast.error('No se pueden guardar cambios en modo ver, debe estar en modo creación o edición')
            return
        }
        //Manejar validaciones

        if (modo == 'creacion') {
          const errores = [
            { cond: !formData.id_sucursal, msg: 'El campo sucursal es obligatorio' },
            { cond: !formData.fecha_hora, msg: 'El campo fecha y hora es obligatorio' },
            { cond: !noEsFechaHoraFutura(formData.fecha_hora), msg: 'La fecha y hora no pueden ser mayores a la actual' },
            { cond: !formData.id_motivo_ajuste_inventario, msg: 'El campo motivo es obligatorio'},
            { cond: !formData.detallesAjuste, msg: 'Debe ingresar al menos un ajuste.'},
            { cond: formData.detallesAjuste?.length < 1, msg: 'Debe ingresar al menos un ajuste.'}

          ];

         for (let error of errores) {
            if (error.cond) {
              toast.error(error.msg);
              return;
            }
          }            
        }

        // setFormData((prev) => ({
        //     ...prev,
        //     total:costoTotal

        // }))

        setCargando(true);

        if (modo == 'creacion') {
                const formDataActualizado = {
                    ...formData,
                    total: costoTotal,
                };
             await instanciaAxios.post('/inventario/ajuste',formDataActualizado)
            toast.success('Ajuste registrado correctamente')

        }else if(modo == 'edicion'){
            await instanciaAxios.put('/inventario/ajuste',{comentario: formData.comentario, id_ajuste_inventario: formData.id_ajuste_inventario})
            toast.success('Ajuste actualizado correctamente')

        }
        setModo('ver')

        } catch (error) {
        console.log(error)
    } finally {
        setCargando(false);
    }
}

    useEffect(() => {
      setEditable(modo == 'creacion');
      if(modo ==='ver'){
        // setProductoSeleccionado(null);
        toast.info('Modo solo observación');
        // setInventarioEditable(false)

      }
      if(modo ==='edicion'){
        // setProductoSeleccionado(null);
        toast.info('Modo edición');
        // setInventarioEditable(false)
      }
      if(modo ==='creacion'){
        // limpiarCampos();
    //    setProductoSeleccionado(null);
        // setInventarioEditable(true)

      // limpiarCampos(camposFormulario,setFormData,setTabsActivos,setNombresCuentas);
      toast.info('Modo creación');
      }
    }, [modo]);

    async function handleSeleccionarAjuste(id_ajuste_inventario) {
        try {
            console.log(id_ajuste_inventario)
            setMostrarModalAjusteInventario(false)
            const respuesta = await instanciaAxios.get('/inventario/ajuste/'+id_ajuste_inventario)
            const datos = respuesta.data
            console.log(datos)
            setFormData((prev) => ({
                ...prev,
                id_ajuste_inventario:id_ajuste_inventario,
                id_sucursal:datos.id_sucursal,
                fecha_hora: formatearFechaHoraInput(datos.fecha_hora),
                id_motivo_ajuste_inventario:datos.id_motivo_ajuste_inventario,
                usuario: datos.nombre_entidad,
                comentario: datos.comentario,
                detalleAjuste:datos.detalles
            }))

            setNombresProductos(
            datos.detalles.map(item => ({
                label: item.descripcion,
                value: item.id_producto
            }))
            );
            setCostoTotal(datos.total)
            console.log(datos)
        } catch (error) {
            console.log(error)
        }
    }

    function handleBotonBuscar() 
    {
     setMostrarModalAjusteInventario(true)
     setModo('ver')   
    }
    
    function handleBotonEditar() 
    {
     setMostrarModalAjusteInventario(true)
     setModo('edicion')   
    }   

    function handleBotonCrear() {
        setModo('creacion')
        limpiarCampos()
    }

    function limpiarCampos() {
        setFormData({
            fecha_hora:obtenerFechaHoraActual(),
            usuario: usuario.nombre +' '+ (usuario.apellido? usuario.apellido : ''),
            comentario: ''

           })
           setCostoTotal(0);
    }
    return (
    cargando?(
      <SpinnerCargando/>
    ):(
        <div className="bg-gray-200 min-h-screen">
            <div className="flex justify-center py-10">
                <div className="bg-gray-100 bg-opacity-90 rounded-xl border border-gray-100 p-12 w-full max-w-7xl mx-10">
                    <form className="flex flex-col gap-8">
                        <div className="space-y-1">
                            <h1 className="font-cascadia font-bold text-2xl">Ajuste de inventario</h1>
                            <p className="text-gray-500">
                                Ajuste manual del inventario por sucursal para corregir discrepancias o registrar cambios puntuales
                            </p>
                        </div>

                  {!editable && (
                    <div className="mb-3 flex items-center gap-2 p-3 bg-yellow-100 border-l-4 border-yellow-500 rounded-md">
                      <MdWarning className="text-yellow-500 text-xl" />
                      <p className="text-yellow-700 font-medium">
                        Si necesita cambiar un ajuste, puede crear uno nuevo. Por razones de seguridad, solo el comentario es editable.
                      </p>
                    </div>
                    )}                        
                        {Object.entries(camposPorSeccion).map(([titulo, campos]) => (
                            <div key={titulo}>
                                <h2 className="text-lg font-semibold mb-4">{titulo}</h2>
                                <div className="grid gap-4 grid-cols-[repeat(auto-fit,_minmax(230px,_1fr))]">
                                    {campos.map((campo) => (
                                        <div key={campo.id} className="flex flex-col">
                                            {campo.custom ? (
                                                <div className="flex flex-col">
                                                    <label htmlFor={campo.id} className="text-sm font-medium text-gray-600 mb-1 flex items-center gap-1">
                                                        {campo.label}
                                                        {campo.required && <span className="text-red-500">*</span>}
                                                    </label>
                                                </div>
                                            ) : campo.type === "checkbox" ? (
                                                <label
                                                    htmlFor={campo.id}
                                                    className={`cursor-pointer px-3 py-2 rounded-xl border text-sm font-medium text-center ${
                                                        formData[campo.id]
                                                            ? 'bg-color-secundario text-white border-color-secundario'
                                                            : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-100'
                                                    }`}
                                                >
                                                    <input
                                                        type="checkbox"
                                                        id={campo.id}
                                                        checked={formData[campo.id] || false}
                                                        onChange={handleChange}
                                                        className="sr-only"
                                                    />
                                                    {campo.label}
                                                </label>
                                            ) : campo.type === "select" ? (
                                                <>
                                                    <label htmlFor={campo.id} className="text-sm font-medium text-gray-600 mb-1 flex items-center gap-1">
                                                        {campo.label}
                                                        {campo.required && <span className="text-red-500">*</span>}
                                                    </label>
                                                    <select
                                                        id={campo.id}
                                                        value={formData[campo.id] || ""}
                                                        onChange={handleChange}
                                                        disabled={!editable}
                                                        className={`w-full p-2 rounded-xl text-gray-700 border-2 outline-none transition-all ${
                                                            campo.required && editable
                                                                ? 'border-red-200 focus:border-red-500 focus:ring-2 focus:ring-red-100' 
                                                                : 'border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100'
                                                        }`}
                                                    >
                                                        <option value="">Seleccione una opción</option>
                                                        {campo.options?.map((option) => (
                                                            <option key={option.value} value={option.value}>
                                                                {option.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </>
                                            ) : campo.type === "texttarea" ? (
                                                <>
                                                    <label htmlFor={campo.id} className="text-sm font-medium text-gray-600 mb-1 flex items-center gap-1">
                                                        {campo.label}
                                                        {campo.required && <span className="text-red-500">*</span>}
                                                    </label>
                                                    <textarea
                                                        id={campo.id}
                                                        disabled={modo == 'ver'}
                                                        className={`w-full p-2 rounded-xl text-gray-700 border-2 outline-none transition-all ${
                                                            campo.required && editable
                                                                ? 'border-red-200 focus:border-red-500 focus:ring-2 focus:ring-red-100' 
                                                                : 'border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100'
                                                        }`}
                                                        value={formData[campo.id]}
                                                        onChange={handleChange}
                                                        placeholder={campo.placeholder}
                                                        rows={3}
                                                    />
                                                </>
                                            ) : (
                                                <>
                                                    <label htmlFor={campo.id} className="text-sm font-medium text-gray-600 mb-1 flex items-center gap-1">
                                                        {campo.label}
                                                        {campo.required && <span className="text-red-500">*</span>}
                                                    </label>
                                                    <input
                                                        type={campo.type}
                                                        id={campo.id}
                                                        disabled={campo.disabled || !editable}
                                                        className={`w-full p-2 rounded-xl text-gray-700 border-2 outline-none transition-all ${
                                                            campo.required && editable
                                                                ? 'border-red-200 focus:border-red-500 focus:ring-2 focus:ring-red-100' 
                                                                : 'border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100'
                                                        }`}
                                                        value={formData[campo.id] || ""}
                                                        onChange={handleChange}
                                                        placeholder={campo.placeholder}
                                                    />
                                                </>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </form>
                    <div className="space-y-3 mt-6">
                        <h2 className="text-lg font-semibold">Productos por ajustar: </h2>
                        {/* <DetalleFacturacion/> */}
                        <TablaDinamica
                        editable={editable}
                        value={formData.detalleAjuste}
                        fields={[
                            {
                            name: "id_producto",
                            label: "Producto",
                            placeholder: "Producto",
                            type: "producto",
                            },
                            {
                            name: "cantidad",
                            label: "Cantidad de ajuste",
                            placeholder: "Cantidad de ajuste",
                            type: "number",
                            },
                            {
                            name: "costo",
                            label: "Costo unitario",
                            placeholder: "Costo unitario",
                            type: "number",
                            },
                            {
                            name: "incrementar",
                            label: "Tipo de ajuste",
                            placeholder: "Tipo de ajuste",
                            type: "select",
                            options: [
                                { value: true, label: "Incrementar" },
                                { value: false, label: "Disminuir" },
                            ],
                            },
                            // Solo mostramos estos campos si el modo es "creacion"
                            ...(modo === "creacion"
                            ? [
                                {
                                    name: "existencia_actual",
                                    label: "Existencia actual",
                                    placeholder: "Existencia actual",
                                    type: "number",
                                    disabled: true,
                                },
                                {
                                    name: "existencia_final",
                                    label: "Existencia final",
                                    placeholder: "Existencia final",
                                    type: "number",
                                    disabled: true,
                                },
                                ]
                            : []),
                        ]}
                        onChange={(data) => handleDetalleAjusteChange(data)}
                        camposRequeridos={["id_producto", "cantidad", "costo", "incrementar"]}
                        nombresProductos={nombresProductos}
                        setNombresProductos={setNombresProductos}
                        tipo_producto={[1]}
                        modificarCosto={true}
                        modificarExistenciaActual={true}
                        tipo_tabla_producto="inventarioPorSucursal"
                        id_sucursal_tabla_producto={formData.id_sucursal}
                        modoTablaDinamica="AjusteInventario"
                        />

                        <div className="mt-2 p-2 bg-color-secundario text-white rounded-xl shadow-lg flex items-center justify-between">
                        <div className="flex items-center gap-2">
                            <FaDollarSign className="text-white text-lg" />
                            <span className="text-md font-semibold">Total en Dinero Movido:</span>
                        </div>
                        <span className="text-xl font-bold tracking-wide">{formatoMoneda(costoTotal)}</span>
                        </div>
                    </div>
                </div>
                <PlantillaModal
                mostrar={mostrarModalAjusteInventario}
                onClose={() => setMostrarModalAjusteInventario(false)}
                >
                    <TablaAjusteInventario setAjusteSeleccionado={handleSeleccionarAjuste}/>
                </PlantillaModal>
                <DockVerticalDerecha
                handleBotonGuardar={()=> submitAjusteInventario()}
                handleBotonBuscar={()=> handleBotonBuscar()}
                handleBotonEditar={() => handleBotonEditar()}
                handleBotonCrear={()=> handleBotonCrear()}
                />
            </div>
        </div>
    )
    );
}

export default ProcesoAjuste;